// @flow

import React from 'react';
import { Redirect } from 'react-router-dom';

import useScrollToTop from '../useScrollToTop';
import usePath from '../usePath';
import useContactNumber from '../useContactNumber';
import useSelfEnrollment from '../../../hooks/useSelfEnrollment';
import PageHeader from '../PageHeader';
import Image from './Image';
import PageButtons from '../PageButtons';
import { SCENARIOS, PATHS, SCENARIO_MAP } from '../constants';

import styles from './styles.module.scss';

const NotifyPatient = () => {
  useScrollToTop();
  const getPath = usePath();
  const contactNumber = useContactNumber();
  const { message, patientData } = useSelfEnrollment();
  const name = patientData?.name ?? '';
  const scenario = SCENARIO_MAP[message] || SCENARIOS.COULD_NOT_VERIFY;

  if (!message) {
    return <Redirect to={getPath(PATHS.IDENTIFY)} />;
  }

  return (
    <div className={styles.container}>
      <Image scenario={scenario} />
      <PageHeader
        headerId={`app.self-enroll.notify.${scenario}.header`}
        subHeaderId={`app.self-enroll.notify.${scenario}.sub-header`}
        values={{ name }}
        alignCenter
      />
      <PageButtons scenario={scenario} phoneNumber={contactNumber} />
    </div>
  );
};

export default NotifyPatient;
